export function formatPostDate(date, lang) {
  if (typeof Date.prototype.toLocaleDateString !== 'function') {
    return date;
  }
  date = localDateFromString(date);
  const day = date.getDate();

  const dayValue = day !== 1 && { day: 'numeric' };
  const args = [lang, { ...dayValue, month: 'long', year: 'numeric' }].filter(Boolean);

  let result = date.toLocaleDateString(...args);
  if (day === 1) {
    return '1er ' + result;
  }
  return result;
}

const monthValue = [
  'jan.',
  'fév.',
  'mars',
  'avril',
  'mai',
  'juin',
  'juil.',
  'août',
  'sept.',
  'oct.',
  'nov.',
  'déc.',
];

const monthLongValue = [
  'janvier',
  'février',
  'mars',
  'avril',
  'mai',
  'juin',
  'juillet',
  'août',
  'septembre',
  'octobre',
  'novembre',
  'décembre',
];

// Lit le jour calendaire écrit dans la chaîne ISO (« 2027-02-15T00:00:00+01:00 » -> 15 février),
// sans conversion de fuseau : un build en UTC afficherait sinon la veille.
function localDateFromString(dateValue) {
  const [year, month, day] = dateValue.slice(0, 10).split('-').map(Number);
  return new Date(year, month - 1, day);
}

export function dayMonthYearFromDate(dateValue, long = false) {
  const date = localDateFromString(dateValue);
  const day = date.getDate();
  const month = long ? monthLongValue[date.getMonth()] : monthValue[date.getMonth()];
  const year = date.getFullYear();

  return { day, month, year };
}

export const formatDay = (day) => (day === 1 ? '1er' : day);

export const generateID = () => '_' + Math.random().toString(36).substr(2, 9);

export function nextSessionsFilter(sessions, courseType) {
  return availableSessions(sessions)
    .filter((session) => session.courseType === courseType)
    .slice(0, 3);
}

export function SessionDateDisplay(nextSession, training) {
  if (!nextSession?.startAt || Number.isNaN(Date.parse(nextSession.startAt))) {
    return 'Aucune session programmée';
  }
  const {
    day: startDateDay,
    month: startDateMonth,
    year: startDateYear,
  } = dayMonthYearFromDate(nextSession.startAt);

  if (training === 'Temps Plein' || training === 'Temps Partiel') {
    const {
      day: endDateDay,
      month: endDateMonth,
      year: endDateYear,
    } = dayMonthYearFromDate(nextSession.endAt);
    return `Du ${formatDay(startDateDay)} ${startDateMonth} ${
      startDateYear === endDateYear ? '' : startDateYear
    } au ${formatDay(endDateDay)} ${endDateMonth} ${endDateYear}`;
  } else {
    return `Le ${formatDay(startDateDay)} ${startDateMonth} ${startDateYear}`;
  }
}

export const formatPrice = (amount) =>
  new Intl.NumberFormat('fr-FR').format(amount).replace(/\s/g, '.') + '€';

// Financement personnel / CPF d'un côté, financements professionnels (CSP, entreprise, OPCO…)
// de l'autre, dans l'ordre renvoyé par l'API.
export function sessionPrices(session) {
  const prices = (session?.prices || []).map((price) => ({
    ...price,
    formatted: formatPrice(price.amount),
  }));
  return {
    personal: prices.find((price) => price.personal) || null,
    professional: prices.filter((price) => !price.personal),
  };
}

export const sessionFieldByCourse = {
  'Temps Plein': 'fullTimeSession',
  Alternance: 'alternanceSession',
  'E-Learning': 'eLearningSession',
};

export function availableSessions(sessions = []) {
  return sessions.filter((session) => Date.parse(session.startAt) > Date.now());
}

export function selectedSession(values, sessionsByType) {
  const id = values[sessionFieldByCourse[values.courseType]]?.id;
  return availableSessions(sessionsByType[values.courseType] || []).find(
    (session) => session.id === id && !session.isFull
  );
}

export function applicationFormat(courseType, format) {
  if (courseType === 'E-Learning') {
    return ['onRemotePersonal', 'onRemoteProfessional'].includes(format) ? format : null;
  }
  return courseType === 'Temps Plein' || courseType === 'Alternance' ? 'onRemote' : format;
}

// `/sessions/apply` : candidature prise par Parcourama (ou par l'email de secours), ou déjà reçue
export function applicationAccepted(response) {
  return ['COMPLETED_SUCCESSFULLY', 'ALREADY_APPLIED'].includes(response?.data?.status);
}
